<div class="detail-guest-wrapper" [class.modal]="pageType === 'modal'">
  <ng-container *ngIf="pageType === 'sidebar'">
    <div class="info">
      <nz-spin nzTip="Loading ..." [nzSpinning]="loading">
        <div class="guests" *ngIf="listOfGuest.length; else empty">
          <div
            class="guest cursor-pointer"
            *ngFor="let guest of listOfGuest"
            (click)="checkGuestDetail(guest)"
            (contextmenu)="checkedGuest = guest; onContextMenu($event, menu)">
            <div class="header">
              <div class="guest-name">
                <span class="name">{{ guest?.name }}</span>
                <div *ngIf="guest?.gender === 1 || guest?.gender === 2">
                  <img
                    class="gender"
                    [src]="guest?.gender === 1 ? '/assets/guest/male.png' : '/assets/guest/female.png'" />
                </div>
              </div>
              <!-- <i class="get-detail" nz-icon nzType="right" nzTheme="outline" (click)="checkGuestDetail(guest)"></i> -->
            </div>

            <div class="labels" *ngIf="guest?.client_tags.length > 0">
              <div class="label" *ngFor="let label of guest?.client_tags" [style.background]="label?.color">
                {{ label?.name }}
              </div>
            </div>
            <div class="guest-info">
              <div class="guest-item" *ngIf="guest?.phone">
                <div class="title">
                  <!-- 手机： -->
                  {{ "order.phone" | translate }}
                </div>
                <div class="content">
                  {{ guest?.phone }} <span style="color: #666; margin-left: 10px">{{ guest?.phone_area }}</span>
                </div>
              </div>
              <div class="guest-item" *ngIf="guest?.email">
                <div class="title">
                  <!-- 邮箱： -->
                  {{ "order.email" | translate }}
                </div>
                <div class="content">{{ guest?.email }}</div>
              </div>
              <div class="guest-item" *ngIf="guest?.id_number">
                <div class="title">
                  <!-- 证件： -->
                  {{ "order.certificate" | translate }}
                </div>
                <div class="content">
                  <span>{{ guest?.id_type | credential }} {{ guest?.id_number }}</span>
                  <span
                    class="pics"
                    (click)="showCredentials(guest?.client_credential)"
                    *ngIf="guest?.client_credential?.length > 0">
                    <img src="/assets/icon/attachment.png" />
                    <span class="number">{{ guest?.client_credential?.length }}</span>
                  </span>
                </div>
              </div>
              <div class="guest-item" *ngIf="guest?.consumer_info?.last_checkin_time">
                <div class="title">
                  <!-- 上次入住： -->
                  {{ "order.last_checkin" | translate }}
                </div>
                <div class="content">
                  <span>
                    {{ guest?.consumer_info?.last_checkin_time | dateformat: ["YMD"] }}
                  </span>
                  <span style="padding-left: 5px">
                    ({{
                      (guest?.consumer_info?.checkin_times === 1
                        ? "order.checkin_times_single"
                        : "order.checkin_times_repeatedly"
                      ) | translate: { i: guest?.consumer_info?.checkin_times }
                    }})
                  </span>
                </div>
              </div>
              <div class="guest-item" *ngIf="guest?.consumer_info?.cumulative_consumer !== 0">
                <div class="title">
                  <!-- 累计消费： -->
                  {{ "order.cumulative_consumption" | translate }}
                </div>
                <div class="content">
                  <span>{{ guest?.consumer_info?.currency_type }}</span>
                  <span style="padding-left: 5px">{{ guest?.consumer_info?.cumulative_consumer }}</span>
                </div>
              </div>
            </div>

            <div
              class="similar"
              *ngIf="guest?.has_similar"
              (click)="$event.stopPropagation(); checkSimilarGuest(guest?.id)">
              <span>
                <!-- 部分信息与其他房客重复 -->
                {{ "order.similar_to_other_guest" | translate }} >
              </span>
            </div>
          </div>
        </div>

        <ng-template #empty>
          <div class="v4-layout-empty my-[100px]">
            <img class="v4-layout-empty-img" src="/assets/icon/no_data.png" />
            <div class="v4-layout-empty-content">
              <div class="v4-layout-empty-title">{{ "order.no_guest" | translate }}</div>
            </div>
          </div>
        </ng-template>
      </nz-spin>
    </div>
    <div class="footer">
      <button nz-button nzSize="large" (click)="closePannel()">
        {{ "word.close" | translate }}
      </button>
      <button nz-button nzSize="large" (click)="addGuest()">
        <!-- 添加房客 -->
        {{ "order.add_guest" | translate }}
      </button>
    </div>
  </ng-container>

  <div class="py-6" *ngIf="pageType === 'modal'">
    <nz-table
      #nzTable
      class="v4-layout-list"
      [nzLoading]="loading"
      [nzFrontPagination]="false"
      [nzData]="listOfGuest"
      [nzTotal]="total"
      [(nzPageIndex)]="page"
      [nzPageSize]="pageSize"
      nzPaginationType="small"
      [nzShowTotal]="totalTpl"
      (nzPageIndexChange)="onPageChange()">
      <thead>
        <tr>
          <th class="w-1/9">
            {{ "guest.list.column.name" | translate }}
            <!-- Name -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.mobile" | translate }}
            <!-- Phone -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.email" | translate }}
            <!-- Email -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.last_stay" | translate }}
            <!-- Last stay at -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.total_consumption" | translate }}
            <!-- Cumulative Amount -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.checkin_time" | translate }}
            <!-- Stays -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.nights" | translate }}
            <!-- Nights -->
          </th>
          <th class="w-1/9">
            {{ "guest.list.column.remarks" | translate }}
            <!-- Remarks -->
          </th>
          <th class="w-1/9"></th>
        </tr>
      </thead>
      <tbody class="v4-layout-list-body">
        <tr *ngFor="let row of nzTable.data">
          <td>
            <div>
              <div>
                {{ row.name }}
                <img
                  *ngIf="row.gender"
                  class="w-[14px] h-[14px]"
                  [src]="row?.gender === 1 ? '/assets/guest/male.png' : '/assets/guest/female.png'" />
              </div>
              <div class="v4-tag-list mt-3" *ngIf="row.client_tags?.length">
                <div class="v4-tag mr-2" [style.backgroundColor]="tag.color" *ngFor="let tag of row.client_tags">
                  {{ tag.name }}
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="v4-layout-text-lines">
              <div class="v4-layout-text-line">{{ row.phone || "-" }}</div>
              <div class="v4-layout-text-line" *ngIf="row.phone_area">{{ row.phone_area }}</div>
            </div>
          </td>
          <td>
            {{ row.email || "-" }}
          </td>
          <td>{{ row?.consumer_info?.last_checkin_time | dateformat: ["YMD"] || "-" }}</td>
          <td>{{ row?.consumer_info?.cumulative_consumer }}</td>
          <td>
            {{ row?.consumer_info?.checkin_times }}
          </td>
          <td>
            {{ row?.consumer_info?.total_nights }}
          </td>
          <td>
            {{ row?.client_comment?.comment || "-" }}
          </td>
          <td>
            <div class="text-right">
              <button nz-button nz-dropdown [nzDropdownMenu]="optMenu" class="no-min-width">
                <i nz-icon nzType="ellipsis"></i>
              </button>
              <nz-dropdown-menu #optMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="deleteGuest(row.id)">Delete</li>
                </ul>
              </nz-dropdown-menu>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #totalTpl>
      {{ "component-page_html_总数" | translate: { number: total } }}
      <!-- {{ total }} items -->
    </ng-template>
  </div>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="deleteGuest(checkedGuest?.id)">
      <!-- 从列表中移除 -->
      {{ "order.remove_guest_in_list" | translate }}
    </li>
    <li nz-menu-item (click)="editGuest(checkedGuest)">
      <!-- 修改 -->
      {{ "word.modify" | translate }}
    </li>
  </ul>
</nz-dropdown-menu>
